import React from "react";
import { IconType } from "react-icons";
import { MdSunny, MdCloud, MdFoggy } from "react-icons/md";
import { IoRainy, IoSnowSharp } from "react-icons/io5";
import { AiFillThunderbolt } from "react-icons/ai";

// Type definitions for TSX
type WeatherCategory = "sunny" | "cloudy" | "foggy" | "rainy" | "snowy" | "thunderstorm";
type WeatherEntry = [string, WeatherCategory];

// 天気名のリスト { 気象コード: [気象名, 気象カテゴリ], ... }
const weatherNames: Record<number, WeatherEntry> = {
  0: ["快晴", "sunny"],
  1: ["晴れ", "sunny"],
  2: ["薄曇り", "cloudy"],
  3: ["曇り", "cloudy"],
  45: ["霧", "foggy"],
  48: ["氷霧", "foggy"],
  51: ["薄い霧雨", "rainy"],
  53: ["霧雨", "rainy"],
  55: ["濃い霧雨", "rainy"],
  56: ["薄い着氷性の霧雨", "rainy"],
  57: ["濃い着氷性の霧雨", "rainy"],
  61: ["小雨", "rainy"],
  63: ["雨", "rainy"],
  65: ["大雨", "rainy"],
  66: ["弱い氷雨", "rainy"],
  67: ["強い氷雨", "rainy"],
  71: ["小雪", "snowy"],
  73: ["雪", "snowy"],
  75: ["大雪", "snowy"],
  77: ["霧雪", "snowy"],
  80: ["にわか雨", "rainy"],
  81: ["通り雨", "rainy"],
  82: ["集中豪雨", "rainy"],
  85: ["弱いにわか雪", "snowy"],
  86: ["強いにわか雪", "snowy"],
  95: ["雷雨", "thunderstorm"],
  96: ["霰を伴う雷雨", "thunderstorm"],
  99: ["雹を伴う雷雨", "thunderstorm"],
};

// 天気アイコンの設定をコンポーネント参照で保持（props を安全に渡すため）
const weatherIcons: Record<WeatherCategory, IconType> = {
  sunny: MdSunny,
  cloudy: MdCloud,
  rainy: IoRainy,
  snowy: IoSnowSharp,
  foggy: MdFoggy,
  thunderstorm: AiFillThunderbolt,
};

// 各カテゴリのデフォルト色
const weatherIconColors: Record<WeatherCategory, string> = {
  sunny: "orange",
  cloudy: "darkgray",
  rainy: "royalblue",
  snowy: "skyblue",
  foggy: "lightgray",
  thunderstorm: "gold",
};

// 気象名&アイコン表示コンポーネント
export const WeatherNameWithIcon: React.FC<{ weatherCode: number }> = ({ weatherCode }) => {
  const [, wCategory] = weatherNames[weatherCode]; // wNameは未使用

  const Icon = weatherIcons[wCategory];
  const wIcon = (
    <Icon
      size={25}
      color={weatherIconColors[wCategory]}
      style={{
        marginRight: "0.5em",
      }}
    />
  );

  return (
    <span style={{ display: "flex", alignItems: "center", paddingLeft: "10px" }}>{wIcon}</span>
  );
};
